module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.details), function(detail) {
    return _c('detail-description', {
      key: detail.label,
      attrs: {
        "icon": detail.icon,
        "label": detail.label,
        "description": detail.description
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bfab542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ListDetailDescription.vue
// module id = 1181
// module chunks = 33 38 49